export default class ValuationAnimations {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new ValuationAnimations;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.animateInElements();
	}

	animateInElements() {
		const self = this,
			$els = $('.anim-fade'),
			$staggerEls = $('.anim-fade-down, .anim-fade-up');

		let timeout = 0;

		$staggerEls.each(function() {
			let $staggerEl = $(this);

			setTimeout(function() {
				$staggerEl.addClass('is-animated-in');

				setTimeout(function() {
					self.resetAnimation($staggerEl);
				}, 600);
			}, timeout);

			timeout += 250;
		});

		$els.addClass('is-animated-in');
	}

	resetAnimation($elements) {
		const self = this;

		// fixes overflow bug
		$elements.css({
			opacity: 1,
			'-webkit-transform': 'none',
			'transform': 'none'
		});
	}
}
